import { CoachingType, Opportunity, OpportunityStatus } from '../general';

import { OpportunityType } from './opportunity-type.model';

export function overrideCoachTypeByComponent(
    item: Opportunity,
    componentItem: Opportunity,
    current: OpportunityType,
): CoachingType {
    if (current === OpportunityType.NO_GOAL) {
        if (
            item.oppStatusId !== OpportunityStatus.ACTIVE &&
            item.oppStatusId !== OpportunityStatus.CLOSED
        ) {
            return CoachingType.NON_OA;
        } else if (componentItem.coachTypeId === CoachingType.COACHED) {
            return componentItem.coachTypeId;
        }
    }
    return item.coachTypeId;
}
